import { createContext } from "react";
const displayModeContext = createContext("light");
export {
  displayModeContext
};
